import { SkeletonLoader } from './SkeletonLoader';

export const DefaultLoadingOverlay = () => <SkeletonLoader numberOfRows={2} />;
